import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Flex } from '@components';
import {Form, Input, Button, Upload, Icon, message,Spin, Radio, Modal} from 'antd';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import {createUuid, getLoginUser} from '@utils/NHCore';
import NHFetch from "@utils/NHFetch";
const Dragger = Upload.Dragger;
import CommonTip from "@pages/SelfHelp/common";
import NextButton from '@pages/SelfHelp/common/nextIndex';
import {mkbz} from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";
import NHFormItem from "@components/common/NHFormItem";
import View from "@pages/SelfHelp/accomCommJsnm/view";
import NHUpload from '@components/common/NHUpload'

const { TextArea } = Input;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { confirm } = Modal
const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 }
};
const formItemLayoutJx = {
    labelCol: { span: 7 },
    wrapperCol: { span: 15 }
};
const basePath = '/jsnm/accomComm';

@Form.create()
export default class AccomCommJsnm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mkbz:'GD006_9',
            hjmc:'',

            nextUrl:'',
            search:'',
           


            operable:true,//是否显示环节
            nonOperationalData:{},//不可操作的数据
            zsqkList: [{'LABEL': '住宿', 'VALUE': '1'}, {'LABEL': '走读', 'VALUE': '0'}], // 住宿情况列表
            zsqk: '', // 住宿情况, '1':住宿, '0': 走读
            data: {}, // 住宿情况详细数据
            editable: true, // 是否可编辑
            saveLoading:false,
            loading:false,

            mbid: ''
        };
    }

    componentDidMount(){
       this.getData();
       this.queryQztjAndYlhj((operable) => {
            if (operable) {
                this.updateZzbdBlzt();
            }
        });
        this.getMbid();
    }

    getMbid = () => {
        NHFetch('/zzbdCommon/getCssz', "GET", {csbz: 'YXXT_JSNM_ZSZDDJMB'})
        .then(res => {
            if (res && res.data) {
                NHFetch('api/zhxg-yxwz/dynamic/'+res.data+'/getDetailed','GET').then(res =>{
                    if (res && res.data){
                        this.setState({
                            mbid: res.data[0].uuid
                        });
                    }
                })
            }
        })
    }

    //迎新现场已办理时迎新网站自动办理
    updateZzbdBlzt = () =>{
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch('/zzbd/updateZzbdBlzt', 'GET',{zzbdhjid:zzbdhjid,hjdm: this.state.mkbz}).then(res => {
            if(res.data){
                this.reloadMenu();
            }
        })
}

    // 获取住宿走读填写数据
    getData = (flag) => {
        let xsid = getLoginUser()?getLoginUser().userId:'';
        NHFetch(basePath + `/get/${xsid}`, 'GET').then(res => {
            if(flag=="edit"){
                this.setState({
                    editable:true
                })
                return;
            }

            NHFetch('/zzbd/getBlztByHjdm','GET',{xsid: xsid, hjdm: this.state.mkbz}).then(res =>{
                if(res){
                    if(res.data == '1'){
                        this.setState({
                            editable: false
                        })
                    }
                }
            })

            if (res && res.data) {
                this.setState({
                    data: res.data,
                    zsqk: res.data.sfzs
                })
            } else {
                this.props.form.resetFields();
            }
        })
    }



    //查询前置条件和依赖环节
    queryQztjAndYlhj=(callback)=>{
        let xsid = getLoginUser()?getLoginUser().userId:'';
        if(!xsid){
            this.setState({
                nonOperationalData:{nologin:true},
                operable:false,
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', {xsid:xsid,zzbdhjid:zzbdhjid})
            .then(res => {
                if (res && res.data) {
                    let kfsj = res.data['kfsj'];
                    let ylhj = res.data['ylhj'];
                    let qzhj = res.data['qzhj'];
                    let nohj = res.data['nohj'];
                    this.setState({nonOperationalData:res.data});
                    if(kfsj && kfsj['YXSJ']!='1'){
                         this.setState({operable:false});
                    }

                    if(ylhj && ylhj.length>0){
                        this.setState({operable:false});
                    }

                    if(qzhj && qzhj.length>0){
                        this.setState({operable:false});
                    }
                    if (nohj) {
                        this.setState({ operable: false });
                    }
                    if (callback) {
                        callback(this.state.operable);
                    }
                    
                }
            });
    }

    getQueryString =(name)=> {
        return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[, ''])[1].replace(/\+/g, '%20')) || null
    }

    


   
    setMenuList=(menuList)=>{
        let nextCount = 0;
        let bz = this.state.mkbz;
        menuList.map((elem,index)=>{
            if(elem.HJDM==bz){
                let hjmc = elem.HJMC;
                this.setState({hjmc:hjmc})
                nextCount = index+1;
                return;
            }
        });
        let menu = menuList[nextCount];
        if(menu){
            let hjdm = menu.HJDM;
            if(hjdm.indexOf('GD')==0){
                let gdUrl = mkbz[hjdm];
                this.setState({
                    nextUrl:gdUrl,
                    search:'pkid='+menu.PKID,
                })
            }else if(hjdm.indexOf('ZDY')==0){
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl:zdyUrl,
                    search:'pkid='+menu.PKID+'&mkbz='+hjdm+'&lx='+menu.LX,
                })
            }
        }else{
            this.setState({
                nextUrl:'',
                search:'',
            })
        }
    }

    //提交
    handleOk = e =>{
        e.preventDefault()
        this.props.form.validateFieldsAndScroll((err, values) => {
            if(err){
                this.setState({loading:false,saveLoading:false});
                return false;
            }
            confirm({
                title: '提示',
                content: '是否确定提交?',
                okText: '确定',
                cancelText: '取消',
                okType: 'danger',
                iconType: 'info-circle',
                onOk: () => {
                    this.saveFile(values['fjid'], () => this.handleSubmit(values))
                },
                onCancel() {
    
                },
            });
        })
        
    }

    handleSubmit = formData => {
        const { zsqk } = this.state;
        let xsid = getLoginUser().userId?getLoginUser().userId:"";
        if(!xsid){
            message.error("登录已过期，请重新登录！");
            return;
        }

        this.setState({loading:true,saveLoading:true}); 
        let zzbdhjid = this.getQueryString('pkid');
            
        let params = {};
        params.xsid = xsid;
        params.sfzs = zsqk;
        params.jzxm = formData['jzxm'];
        params.jzdh = formData['jzdh'];
        params.jzdxxdz = formData['jzdxxdz'];
        params.sqzdly = formData['sqzdly'];
        params.hjblFlag = true;
        params.zzbdhjid = zzbdhjid;
        params.pkid = formData['pkid'];
        params.fjid = formData['fjid'];
    
        NHFetch(`${basePath}/save`,"POST",params)
        .then(res => {
            if (res && res.data && res.code == 200) {
                message.success("住宿走读情况提交成功");
                this.getData();
                this.reloadMenu(); 
            } else {
                message.success("住宿走读情况提交失败，请重试。");
            }
            this.setState({ loading: false,editable:false,saveLoading:false })
        }).catch((res) => {
        this.setState({ loading: false,saveLoading:false })
        return res;
        });
    }

    saveFile = (fjzbid, callback) => {
        //保存附件主表id
        return NHFetch('api/zhxg-yxwz/dynamic/save', 'POST', [fjzbid]).then(res => {
          if (res && res.code === 200) {
            //保存成功，执行相应操作
            callback();
          } else {
            message.error('附件保存失败')
          }
        })
    }

    //重新加载菜单
    reloadMenu=()=>{
        this.refs.siderMenu.reloadMenuList()
    }

    handleDownload = async (fjid) => {
        if (!fjid) {
            message.error('未设置模板，请联系管理员设置模板');
            return;
        }

        window.open("zuul/docrepo/download/file?attachmentId=" + fjid);
    };


    render() {
        const {form} = this.props;
        const { getFieldDecorator } = this.props.form;
        const { data, hjmc, editable, zsqkList, zsqk, mkbz, mbid } = this.state;
       

        return (
            <div style={{position:'relative'}}>{this.state.operable?
                <div>
                <Flex className="w1180 mt-20" align="start">
                    <SiderMenu
                                ref={"siderMenu"}
                                setMenuList={this.setMenuList}
                                title="自助报到"
                                mkbz = {this.state.mkbz}
                          /*     active={4}*/
                                menuType='自助报到'/>
                    <Flex.Item className="page_con_r" styleName="">
                        <Breadcrumb
                            noLine
                            list={[
                                { name: '首页', url: '/index' },
                                { name: '自助报到', url: '/register' },
                                { name: this.state.hjmc }
                            ]}
                        />
                        <div className="box">
                            <Hint/>
                            {editable?<Form>
                                <TitleTop title="登记信息" extra={false} />
                                <div className="p-sw">

                                    <div style={{display:'none'}}>
                                    <NHFormItem id={'pkid'} initialValue={data['pkid']} form={form}>
                                        <Input/>
                                    </NHFormItem>
                                    </div>

                                    <div className="form_item" style={{marginLeft: '7%'}}>
                                    <NHFormItem required={true} id={'sfzs'} initialValue={data['sfzs']} form={form}  formItemLayout = {formItemLayout} label="住宿情况">
                                        <Radio.Group onChange={(e) => this.setState({zsqk: e.target.value})} value={zsqk} style={{display:"flex",margin:"10px"}}>
                                            {
                                                zsqkList && zsqkList.map((item,index)=>{
                                                   return <Radio value={item.VALUE}>{item.LABEL}</Radio>
                                                })
                                            }
                                        </Radio.Group>
                                    </NHFormItem>
                                    </div>
                                    {zsqk=='0' && <div className="form_item" style={{marginLeft: '7%'}}>
                                        <NHFormItem required={false} id={'jzxm'} initialValue={data['jzxm']} form={form}  formItemLayout = {formItemLayout} label="家长姓名">
                                            <Input maxLength ={6} placeholder="请填写家长姓名" />
                                        </NHFormItem>
                                        <NHFormItem required={false} id={'jzdh'} initialValue={data['jzdh']} form={form}  formItemLayout = {formItemLayout} label="家长电话">
                                            <Input maxLength ={6} placeholder="请填写家长电话" />
                                        </NHFormItem>
                                        <NHFormItem required={false} id={'jzdxxdz'}  initialValue={data['jzdxxdz']} form={form}  formItemLayout = {formItemLayout} label="居住地详细地址">    
                                            <TextArea maxLength ={50} placeholder="请填写居住地详细地址" />
                                        </NHFormItem>
                                        <NHFormItem required={false} id={'sqzdly'}  initialValue={data['sqzdly']} form={form}  formItemLayout = {formItemLayout} label="走读理由">    
                                            <TextArea maxLength ={50} placeholder="请填写走读理由" />
                                        </NHFormItem>
                                        <NHFormItem required={false} id={'fjid'}  initialValue={data['fjid']} form={form}  formItemLayout = {formItemLayout} label={<span>附件上传(<span style={{color: '#397ef0'}}onClick={() => this.handleDownload(mbid)}>模板</span>)</span>}>  
                                            <NHUpload
                                                serviceMark={'ly-sm-yxwz-svc'}
                                                moduleName={'附件上传'}
                                                multiple={false}
                                                fileCountLimit={1}
                                                isEdit={editable}
                                                defaultEffective={true}
                                                // fileTypeLimit={['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG']}
                                            />
                                        </NHFormItem>
                                    </div>}
                                </div>
                            
                                <div className="text-center mt-50">
                                    <Button type="primary" htmlType="submit" onClick={this.handleOk} loading={this.state.saveLoading}>
                                        提交
                                    </Button>
                                    <NextButton nextUrl={this.state.nextUrl}  search={this.state.search}/>
                                </div>
                            </Form>
                            :<View nextUrl={this.state.nextUrl} search={this.state.search} getData={()=>this.getData("edit")}  data={this.state.data} />}
                        </div>
                    </Flex.Item>
                </Flex>
                    <Spin style={{ position:'absolute',top:'300px',left:'60%'}} spinning={this.state.loading}/> </div>:<CommonTip hjmc = {hjmc}  key={mkbz} mkbz={mkbz} nonOperationalData={this.state.nonOperationalData}/>}
            </div>

        );
    }
}
